import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { motion, AnimatePresence } from 'framer-motion';

import { updateIndexMapTransform, updateAreaMapTransform } from '../store/globalReducer';

import WelcomeScreen from '../components/WelcomeScreen';
import PageTransitionOverlay from '../components/PageTransitionOverlay';


import Map from '../components/Map';

import '../assets/scss/components/map.scss';
import '../assets/scss/pages/index.scss';

import indexMap from '../assets/img/index/map-index-850.jpg';
import areaMap from '../assets/img/area/map-area-850.jpg';
import bgPattern from '../assets/img/detail/bg_pattern.png';

function MapTransitionWrap(props) {
  return (
    <motion.div
    {...props}
    animate={{ opacity: 1, transition: { delay: 0.5 } }}
    exit={{ opacity: 0, transition: { delay: 0.5 } }}>
        {props.children}
    </motion.div>
  )
}

export default function Index() {
  const indexPinList = useSelector(state => state.temples.templeData.filter(el => el.show_on_map === 'index'));
  const areaPinList = useSelector(state => state.temples.templeData.filter(el => el.show_on_map === 'area'));

  const indexMapTransform = useSelector(state => state.global.indexMapTransform);
  const areaMapTransform = useSelector(state => state.global.areaMapTransform);
  const isAreaOpen = useSelector(state => state.global.isAreaOpen);
  const [initOpacityVal, setInitOpacityVal] = useState(isAreaOpen);

  useEffect(() => setInitOpacityVal(isAreaOpen ? 1 : 0), [isAreaOpen]);

  useEffect(() => {
    document.body.classList.add('no-scroll');
  }, []);

  return (
    <div className="page-index" style={{ backgroundImage: `url(${bgPattern})` }}>
      <WelcomeScreen />

      <AnimatePresence>
        {!isAreaOpen && (
          <MapTransitionWrap initial={{ opacity: !initOpacityVal }}>
            <Map
              isIndex={true}
              mapImage={indexMap}
              pinList={indexPinList}
              mapTransform={indexMapTransform}
              updateMapTransform={updateIndexMapTransform}>
            </Map>
          </MapTransitionWrap>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {isAreaOpen && (
          <MapTransitionWrap
            className="map-overlay"
            style={{ backgroundImage: `url(${bgPattern})` }}
            initial={{ opacity: initOpacityVal }}>
            <Map
              isIndex={false}
              mapImage={areaMap}
              pinList={areaPinList}
              mapTransform={areaMapTransform}
              updateMapTransform={updateAreaMapTransform}>
            </Map>
          </MapTransitionWrap>
        )}
      </AnimatePresence>

      <PageTransitionOverlay />
    </div>
  );
}